import { Component, OnInit, OnChanges, OnDestroy, Input } from '@angular/core';
import { ProfileService } from '../../shared/profile.service';
import { AffProsAndAffCodeType } from '../../shared/model/aff-pros-and-aff-code-type.model';
import { ObservationService } from '../../../shared/observation/observation.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'wl-profile-view-affiliation',
  templateUrl: 'affiliation.component.html',
  styleUrls: ['affiliation.component.css'],
    standalone: false
})
export class ProfileViewAffiliationComponent implements OnInit, OnChanges, OnDestroy {
  private _profileService: ProfileService;
  private _observationService: ObservationService;
  private _profileSubscription: Subscription;

  public affiliations: Array<AffProsAndAffCodeType>;
  public affCount: number;

  @Input() public profileId: number;

  public constructor(profileService: ProfileService, observationService: ObservationService) {
    this._profileService = profileService;
    this._observationService = observationService;
    this.affiliations = new Array<AffProsAndAffCodeType>();
    this.affCount = 0;
  }

  ngOnInit() {
    this._profileSubscription = this._observationService.observeProfiles().subscribe((id) => {
      this.profileUpdated(id);
    });

    this.loadData();
  }

  ngOnChanges() {
    this.loadData();
  }

  ngOnDestroy() {
    if (this._profileSubscription) {
      this._profileSubscription.unsubscribe();
    }
  }

  private profileUpdated(id: number) {
    if (id === this.profileId) {
      this.loadData(true);
    }
  }

  private loadData(forceRefresh?: boolean) {
    this._profileService.getProfileAffCodesByAffCodeType(this.profileId, forceRefresh).then((data: Array<AffProsAndAffCodeType>) => {
      this.affiliations = data;
      this.affiliations.sort((a, b) => {
        return a.AffCodeType.toLowerCase().localeCompare(b.AffCodeType.toLowerCase());
      });
      this.affCount = 0;
      for (const type of data) {
        this.affCount += type.AffPros.length;
      }
      this.sortAffCodes();
    });
  }

  private sortAffCodes() {
    this.affiliations.forEach((affs) => {
      affs.AffPros.sort((a, b) => {
        return a.toLowerCase().localeCompare(b.toLowerCase());
      });
    });
  }
}
